// Generated by purs version 0.15.15
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
import * as Halogen_Styled_DSL from "../Halogen.Styled.DSL/index.js";
import * as Visonum_BulkPingApp_AppHTML from "../Visonum.BulkPingApp.AppHTML/index.js";
import * as Visonum_BulkPingApp_Components_App_Types from "../Visonum.BulkPingApp.Components.App.Types/index.js";
import * as Visonum_BulkPingApp_Views_PrimaryButton from "../Visonum.BulkPingApp.Views.PrimaryButton/index.js";
import * as Visonum_BulkPingApp_Views_TextInput from "../Visonum.BulkPingApp.Views.TextInput/index.js";
var inline = /* #__PURE__ */ Halogen_Styled_DSL.inline();
var viewLogin = function (state) {
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Login")([ inline({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: "20px"
    }) ]);
    var elInput = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Input")([  ]);
    var elButton = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Button")([  ]);
    return elRoot([  ])([ elInput([  ])([ Visonum_BulkPingApp_Views_TextInput.view({
        multiline: Visonum_BulkPingApp_Views_TextInput.defaultProps.multiline,
        label: "",
        value: state.spmApiKey,
        onChange: Visonum_BulkPingApp_Components_App_Types.SetPassword.create,
        onEnter: new Data_Maybe.Just(Visonum_BulkPingApp_Components_App_Types.Login.value),
        password: true
    }) ]), elButton([  ])([ Visonum_BulkPingApp_Views_PrimaryButton.view({
        label: "Login",
        onClick: Visonum_BulkPingApp_Components_App_Types.Login.value,
        disabled: false
    }) ]) ]);
};
var viewFailure = /* #__PURE__ */ (function () {
    var elTryAgain = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("TryAgain")([ inline({}) ]);
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Checking")([ inline({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: "20px",
        fontSize: "20px",
        fontFamily: "Arial"
    }) ]);
    return elRoot([  ])([ Halogen_Styled.text("Login failed"), elTryAgain([  ])([ Visonum_BulkPingApp_Views_PrimaryButton.view({
        label: "Try again",
        onClick: Visonum_BulkPingApp_Components_App_Types.Logout.value,
        disabled: false
    }) ]) ]);
})();
var viewChecking = /* #__PURE__ */ (function () {
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Checking")([ inline({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: "20px",
        fontSize: "20px",
        fontFamily: "Arial"
    }) ]);
    return elRoot([  ])([ Halogen_Styled.text("Loggin in...") ]);
})();
var view = function (state) {
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Login")([ inline({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: "20px",
        position: "relative"
    }) ]);
    return elRoot([  ])([ (function () {
        if (state.logInState instanceof Visonum_BulkPingApp_Components_App_Types.LoginChecking) {
            return viewChecking;
        };
        if (state.logInState instanceof Visonum_BulkPingApp_Components_App_Types.LoginNotTried) {
            return viewLogin(state);
        };
        if (state.logInState instanceof Visonum_BulkPingApp_Components_App_Types.LoginSuccess) {
            return viewLogin(state);
        };
        if (state.logInState instanceof Visonum_BulkPingApp_Components_App_Types.LoginFailure) {
            return viewFailure;
        };
        throw new Error("Failed pattern match at Visonum.BulkPingApp.App.Login (line 34, column 9 - line 38, column 38): " + [ state.logInState.constructor.name ]);
    })() ]);
};
export {
    view
};
//# sourceMappingURL=index.js.map
